const setIncomeValue = (store) => (field) => (value) => {
    store.send('UPDATE', { field, value });
};
const getIncome = (store) => () => {
    return store.state.context.income;
};
const getDetails = (store) => () => {
    return store.state.context.details;
};
const setDetails = (store) => (details) => {
    store.send('ADD_DETAILS', { details });
};
const incomeRepository = (store) => {
    return {
        setIncomeValue: setIncomeValue(store),
        getIncome: getIncome(store),
        getDetails: getDetails(store),
        setDetails: setDetails(store),
    };
};
export { incomeRepository };
